"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var RequestData_1 = __importDefault(require("../../classes/RequestData"));
var event_bus_1 = require("../../event-bus");
var request_1 = __importDefault(require("../../request"));
var echo_1 = __importStar(require("../../echo"));
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var UsersMixin = /** @class */ (function (_super) {
    __extends(UsersMixin, _super);
    function UsersMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.users = new RequestData_1.default();
        return _this;
    }
    UsersMixin.prototype.created = function () {
        event_bus_1.EventBus.$on(event_bus_1.events.user.all, this.requestUsers)
            .$on(event_bus_1.events.user.create, this.onUserCreateEvent)
            .$on(event_bus_1.events.user.update, this.onUserUpdateEvent)
            .$on(event_bus_1.events.user.delete, this.onUserDeleteEvent)
            .$on(event_bus_1.events.common.search.phrase, this.onSearchPhraseInput)
            .$on(event_bus_1.events.common.search.hit, this.requestUsersFirstPage);
        echo_1.default.channel(echo_1.channels.user)
            .listen(echo_1.events.user.create, this.requestUsers)
            .listen(echo_1.events.user.update, this.updateUser)
            .listen(echo_1.events.user.delete, this.requestUsers);
    };
    UsersMixin.prototype.beforeDestroy = function () {
        event_bus_1.EventBus.$off(event_bus_1.events.user.all, this.requestUsers)
            .$off(event_bus_1.events.user.create, this.onUserCreateEvent)
            .$off(event_bus_1.events.user.update, this.onUserUpdateEvent)
            .$off(event_bus_1.events.user.delete, this.onUserDeleteEvent)
            .$off(event_bus_1.events.common.search.phrase, this.onSearchPhraseInput)
            .$off(event_bus_1.events.common.search.hit, this.requestUsersFirstPage);
        echo_1.default.leave(echo_1.channels.user);
    };
    UsersMixin.prototype.requestUsers = function (page) {
        return request_1.default.user.all(this.users.search, page || this.users.pagination.current_page, this.updateUsers);
    };
    UsersMixin.prototype.requestUsersFirstPage = function () {
        return this.requestUsers(1);
    };
    UsersMixin.prototype.onUserCreateEvent = function (user) {
        return request_1.default.user.create(user, this.requestUsers);
    };
    UsersMixin.prototype.onUserUpdateEvent = function (user) {
        return request_1.default.user.update(user.id, { attribute: user.attribute, value: user.value }, this.updateUser);
    };
    UsersMixin.prototype.onUserDeleteEvent = function (user) {
        return request_1.default.user.delete(user.id, this.requestUsers);
    };
    UsersMixin.prototype.onSearchPhraseInput = function (search) {
        this.updateSearchPhrase(search);
    };
    UsersMixin.prototype.updateUsers = function (users, pagination) {
        this.users = this.users
            .setArray(users)
            .setPagination(pagination);
    };
    UsersMixin.prototype.updateUser = function (user) {
        this.users = this.users.updateArray(user);
    };
    UsersMixin.prototype.updateSearchPhrase = function (search) {
        this.users = this.users.setSearch(search);
    };
    UsersMixin = __decorate([
        vue_class_component_1.default
    ], UsersMixin);
    return UsersMixin;
}(vue_property_decorator_1.Vue));
exports.default = UsersMixin;
